import type { ReactNode } from "react";
import { useTranslate } from "@refinedev/core";
import { LogoutIcon } from "@fawkes/ui";

import type { Page } from "./nav";
import "./foster-shell.css";

// fix/foster-login-redesign (dashboard): the bespoke foster-portal shell — the green sidebar + warm
// canvas from the "pleeggezinnen-dashboard-react" mockup. Rendered for the FOSTER role instead of the
// shared AppShell (App.tsx), so the portal matches the design; admin / self-service keep the AppShell.
// Nav items + logout are wired from App.tsx (same state-based navigation). The brand mark reuses the
// real Docasoft logo (public/brand-paw-circle.svg, as on the login).

export type FosterNavItem = {
  page: Page;
  label: string;
  icon: ReactNode;
  active: boolean;
  onClick: () => void;
};

export function FosterShell({
  items,
  onLogout,
  children,
}: {
  items: FosterNavItem[];
  onLogout: () => void;
  children: ReactNode;
}) {
  const t = useTranslate();
  return (
    <div className="foster-shell">
      <aside className="foster-shell__sidebar">
        <div className="foster-shell__logo">
          <img src="/brand-paw-circle.svg" alt="" width={44} height={44} />
          <div>
            <div className="foster-shell__brand">{t("shell.brand")}</div>
            <div className="foster-shell__brandsub">{t("shell.applicationTitle")}</div>
          </div>
        </div>

        <nav className="foster-shell__nav" aria-label={t("shell.applicationTitle")}>
          {items.map((it) => (
            <button
              key={it.page}
              type="button"
              className={`foster-shell__navitem${it.active ? " is-active" : ""}`}
              onClick={it.onClick}
              aria-current={it.active ? "page" : undefined}
            >
              {it.icon}
              <span>{it.label}</span>
            </button>
          ))}
        </nav>

        <div className="foster-shell__spacer" />

        <button type="button" className="foster-shell__logout" onClick={onLogout}>
          <LogoutIcon width={22} height={22} />
          <span>{t("shell.profile.logout")}</span>
        </button>
      </aside>

      <div className="foster-shell__content">{children}</div>
    </div>
  );
}
